import './styles.sass'

import React, { FC } from 'react'

interface IAvatar {
  name: string,
  size: 'sm' | 'reg'
}

const Avatar: FC<IAvatar> = ({ name, size }) => {
  return (
    <span className={`avatar avatar-none ${size}`}>
      {name?.split('')[0]}
    </span>
  )
}

export default Avatar